export default function stripHtml(html) {
    var div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
}


// WEBPACK FOOTER //
// ./src/app/utils/stripHtml.js